import React from "react";
import UserLogin from "../components/Screens/Login/login";
import "./index_home.css";

export default () => {
  return <UserLogin />;
};



// WEBPACK FOOTER //
// ./src/app/components/index_home.jsx